// 当鼠标点击 ref 之外的区域触发, 在鼠标重新点击ref内之前，只触发一次。

import { useClickAway, useEventListener } from 'ahooks';
import { RefObject, useState } from 'react';

const WHITE_LIST = [
  // antd select ，dropdown
  'modern-select-item-option-content',
  'ant-select-item-option-content',
];

export const useBlurPanel = (
  ref: RefObject<HTMLDivElement>,
  onBlur: () => void,
) => {
  const [focus, setFocus] = useState(false);

  useEventListener(
    'click',
    () => {
      setFocus(true);
    },
    { target: ref },
  );

  useClickAway((e: PointerEvent) => {
    if (!focus) return;
    if (WHITE_LIST.includes((e.target as HTMLElement)?.className)) return;
    onBlur();
    setFocus(false);
  }, ref);
};
